import { systemNames } from '@it/orpk-vue-ts'

export default {
  urlsWithoutInterceptors: ['/logs/client'],
  systemTitle: {
    fullName: systemNames.science.full,
    shortName: systemNames.science.short
  },
  routing: {
    homePage: {
      path: '/publications/all',
      name: 'Все публикации'
    },
    authPage: {
      path: '/auth',
      name: 'Авторизация в системе'
    }
  },
  mobileWidth: 768,
  defaultWidth: 1000,
  fileSizeText: '5 Мб',
  fileSize: 5242880, // 1 Mb
  allFilesSizeText: '10 Мб',
  allFilesSize: 10485760, // 10 Mb
  imageFileSizeText: '5 Мб',
  imageFileSize: 5242880
}
